import { useEffect, useState } from 'react';

import Button from 'components/Button';

import styles from 'styles/modules/Feed.module.scss';

import { feed } from 'lang/en.json';
import Card from 'components/Card';
import getCharacters from 'helpers/getCharacters';
import tagRemove from 'utils/tag-remove';
import NotFound from 'components/NotFound';
import Typo from 'components/Typo';

const resultsPerPage = 3;
const FeedList = ({ data, type }) => {
    const [cardsToShow, setCardsToShow] = useState(data);
    const [loadMoreActive, setLoadMoreActive] = useState(false);
    const [next, setNext] = useState(resultsPerPage);

    let holdingResults = [];
    const loopWithSlice = (end) => {
        const slicedResults = data.slice(0, end);
        holdingResults = slicedResults ? [...slicedResults] : null;
        setCardsToShow(holdingResults);

        if (end >= data.length) {
            setLoadMoreActive(false);
        } else {
            setLoadMoreActive(true);
        }
    };

    useEffect(() => {
        loopWithSlice(resultsPerPage);
    }, []);

    const handleLoadMore = () => {
        const nextNum = next + resultsPerPage;
        loopWithSlice(nextNum);
        setNext(nextNum);
    };

    return (
        <>
            <Typo variant={'h2'} className={'styles.title'}>
                {feed[`news_${type}`].title}
            </Typo>
            <div className={styles.cardsWrapper}>
                {cardsToShow.length > 0 ? (
                    cardsToShow.map((item) => (
                        <Card
                            id={item.id}
                            title={getCharacters(item.title, 50)}
                            body={getCharacters(tagRemove(item.body), 120)}
                            link={
                                type === 'story'
                                    ? `${item.company.slug}/news-story/${item.slug}`
                                    : `/news-alerts/${item.slug}`
                            }
                            key={`card-item-${item.id}`}
                            publishedAt={item.publicationDate}
                            linkOverlay
                            feed
                            {...(type === 'story'
                                ? {
                                      author: {
                                          ...(item.expert
                                              ? {
                                                    ...item.expert,
                                                    slug: item.company.slug,
                                                }
                                              : item.company),
                                      },
                                  }
                                : { alert: true })}
                        />
                    ))
                ) : (
                    <NotFound text={feed[`news_${type}`].no_news_alert} />
                )}
            </div>
            {loadMoreActive && (
                <div className={styles.loadMore}>
                    <Button title="Load more" onClick={handleLoadMore} />
                </div>
            )}
            <div className={styles.divider} />
        </>
    );
};

export default FeedList;
